// src/utils/pageTracker.js
import FingerprintJS from "@fingerprintjs/fingerprintjs";

export const usePageTracker = () => {
  // 初始化跟踪参数
  const init = () => {
    if (!sessionStorage.getItem("landingPage")) {
      sessionStorage.setItem("landingPage", window.location.href);
    }

    if (
      !sessionStorage.getItem("referrer") &&
      document.referrer &&
      !document.referrer.includes(window.location.hostname)
    ) {
      sessionStorage.setItem("referrer", document.referrer);
    }
  };

  // 生成带跟踪参数的URL
  const generateTrackedUrl = async (registerUrl) => {
    // 确保registerUrl是字符串类型
    let urlString = String(registerUrl || "");
    try {
      // 获取指纹信息
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      const requesterId = result.visitorId;
      console.log("requesterId:", requesterId);
      urlString =
        urlString +
        "?sourceLink=" +
        encodeURIComponent(sessionStorage.getItem("referrer")) +
        "&landingPage=" +
        encodeURIComponent(sessionStorage.getItem("landingPage") || "") +
        "&registerLink=" +
        encodeURIComponent(window.location.href) +
        "&requestId=" +
        requesterId;
    } catch (error) {
      console.error("获取指纹信息失败:", error);
      // 出错时仍返回原始URL
    }

    return urlString;
  };

  // 初始化调用
  init();

  return {
    generateTrackedUrl,
    openInNewTab: (url) => {
      generateTrackedUrl(url).then((updatedUrl) => {
        window.open(updatedUrl, "_blank");
      });
    },
  };
};
